export const SCROLLBAR_SIZE = 10;
export const VIEWPORT_PADDING = 25;
